<template>
    <form v-on:submit.prevent="sendMessage" class="sender-form">
        <div class="sender-form__field">
            <label class="form-label sender-form__label">{{ $filters.localize("MessageDetail.type") }}</label>
            <select class="form-control sender-form__control" v-model="typeId" required>
                <option v-for="option in typesFilter" v-bind:key="option.id" :value="option.id">
                    {{ option.name }}
                </option>
            </select>
        </div>
        <div v-if="typeId == 1" class="sender-form__field">
            <label class="form-label sender-form__label">{{ $filters.localize("MessageDetail.period") }}</label>
            <div class="sender-form__grid">
                <div class="input-group">
                    <label class="form-control sender-form__addon">{{ $filters.localize("MessageDetail.from") }}</label>
                    <input type="date" v-model="period.start" class="form-control sender-form__control" required>
                </div>
                <div class="input-group">
                    <label class="form-control sender-form__addon">{{ $filters.localize("MessageDetail.to") }}</label>
                    <input type="date" v-model="period.end" class="form-control sender-form__control" required>
                </div>
            </div>
        </div>
        <div v-else-if="typeId == 0 && !contactId" class="sender-form__field">
            <label class="form-label sender-form__label">{{ $filters.localize("ContactPage.caption") }}</label>
            <select class="form-control sender-form__control" v-model="currentContactId" required>
                <option v-for="option in contacts" v-bind:key="option.id" :value="option.id">
                    {{ option.fullName }}
                </option>
            </select>
        </div>
        <div v-if="typeId != 1" class="sender-form__field">
            <label class="form-label sender-form__label">{{ $filters.localize("MessageDetail.caption") }}</label>
            <textarea
                type="text"
                v-model="text"
                class="form-control sender-form__control sender-form__textarea"
                v-bind:placeholder="$filters.localize('MessageDetail.caption')"
            ></textarea>
        </div>
        <div class="sender-form__footer">
            <button class="btn btn-primary sender-form__submit" type="submit">
                {{ $filters.localize("button.send") }}
            </button>
        </div>
    </form>
</template>

<script>
export default {
    name: "SenderDetail",
    emits: ["sent"],
    props:{
        contactId: { type:String },
    },
    computed:{
        typesFilter: {
            get() {
                if(this.contactId)
                    return this.types.filter(x => x.id == 0);
                else 
                    return this.types;
            }
        }
    },
    data(){
        return {
            types: [
                { id: 0, name: "Персонально" },
                { id: 1, name: "Відправити за ТТН за період" },
                { id: 2, name: "Надіслати всім" },
            ],
            contacts:[],
            currentContactId: null,
            text: "",
            typeId: 2,
            period:{
                start: "",
                end: ""
            }          
        };
    },
    mounted() {
        this.loadRows();        
    },    
    methods:{
        loadRows() {
            this.$store.dispatch('section', { table: "contact", body: {}})
                .then((response) => {
                    this.contacts =  response.data.data;
                    this.currentContactId = this.contactId;
            });
        },
        sendMessage() {
            switch(this.typeId){
                case 1:
                    this.sendPeriodTTNMessage()
                    break;
                case 2:
                    this.sendAllMessage();
                    break;
                default:{
                    this.sendPersonalMessage();
                    break;
                }
            }
        },
        sendPersonalMessage(){
            if(!this.currentContactId){
                this.$toast.error("Відсутній клієнт");
                return;
            }
            this.$store.dispatch("postAPI", 
            { 
                controller:"Sender", 
                method:"SendMessage", 
                body: { contactId: this.currentContactId, text: this.text } 
            })
            .then(() => {
                this.$toast.success("Повідомлення успішно відправлено");
                this.$emit("sent");
            })
            .catch(error => this.$toast.error(error.response.data.message));
        },
        sendPeriodTTNMessage(){
            if(!this.period.start || !this.period.end || (this.period.end < this.period.start)){
                this.$toast.error("Період заданий некоректно");
                return;
            }
            this.$store.dispatch("postAPI", 
            { 
                controller:"Sender", 
                method:"SendTTNByPeriod", 
                body: { start: this.period.start, end: this.period.end } 
            })
            .then((response) => {
                this.$toast.success("Повідомлень надіслано: " + response.data.data);
                this.$emit("sent");
            })
            .catch(error => this.$toast.error(error.response.data.message));
        },
        sendAllMessage(){
            if(!this.text){
                this.$toast.error("Відсутній текст повідомлення");
                return;
            }
            this.$store.dispatch("postAPI", 
            { 
                controller:"Sender", 
                method:"SendAllMessage", 
                body: { text: this.text } 
            })
            .then((response) => {
                this.$toast.success("Повідомлень надіслано: " + response.data.data);
                this.$emit("sent");
            })
            .catch(error => this.$toast.error(error.response.data.message));
        }
    },
}
</script>

<style scoped>
    .sender-form {
        display: grid;
        grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);
        gap: 8px 10px;
        align-items: end;
        text-align: left;
    }

    .sender-form__field {
        display: flex;
        flex-direction: column;
        min-width: 0;
    }

    .sender-form__label {
        margin-bottom: 3px;
        color: #526171;
        font-size: 0.74rem;
        font-weight: 700;
        line-height: 1.15;
    }

    .sender-form__control,
    .sender-form__addon {
        min-height: 32px;
        height: 32px;
        padding: 4px 8px;
        border-color: #ced4da;
        border-radius: 4px;
        font-size: 0.84rem;
        line-height: 1.2;
    }

    .sender-form__addon {
        max-width: 76px;
        color: #526171;
        background: #f8fafc;
        font-weight: 700;
    }

    .sender-form__textarea {
        height: auto;
        min-height: 76px;
        resize: vertical;
    }

    .sender-form__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
    }

    .sender-form__footer {
        display: flex;
        align-self: end;
        justify-content: flex-end;
        grid-column: 2;
    }

    .sender-form__submit {
        min-width: 92px;
        min-height: 28px;
        padding: 3px 10px;
        border-radius: 4px;
        font-size: 0.78rem;
        font-weight: 700;
    }

    .sender-form__field:has(.sender-form__textarea) {
        grid-column: 1 / -1;
    }

    @media (max-width: 575.98px) {
        .sender-form {
            grid-template-columns: 1fr;
        }

        .sender-form__grid {
            grid-template-columns: 1fr;
        }

        .sender-form__footer {
            grid-column: 1;
        }

        .sender-form__submit {
            width: auto;
        }
    }
</style>
